export const BATCH = 'BATCH';
export const HIDDEN_BATCH = 'HIDDEN_BATCH';
export const UNDOABLE_BATCH = 'UNDOABLE.BATCH';

export function batchActions(actions) {
  return { type: BATCH, payload: actions };
}

export function batchHiddenActions(actions) {
  return { type: HIDDEN_BATCH, payload: actions };
}

export function batchUndoableActions(actions, options = {}) {
  const { skipHistory = false } = options;
  return {
    type: UNDOABLE_BATCH,
    payload: actions,
    skipHistory,
  };
}

export function enableBatching(reduce) {
  return function batchingReducer(state, action) {
    switch (action.type) {
      case BATCH:
      case UNDOABLE_BATCH:
        return action.payload.reduce(batchingReducer, state);
      default:
        return reduce(state, action);
    }
  };
}

export function enableHiddenBatching(reduce) {
  return function batchingReducer(state, action) {
    switch (action.type) {
      case HIDDEN_BATCH:
        return action.payload.reduce(batchingReducer, state);
      default:
        return reduce(state, action);
    }
  };
}



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Builder/reducers/batchReducer.js